var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":"","dark":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var tooltipOn = ref.on;
return [_c('v-btn',_vm._g({class:{ 'v-btn--active': _vm.manageActive },attrs:{"icon":"","to":"/manage"}},tooltipOn),[_c('v-icon',[_vm._v("mdi-cog")])],1)]}}])},[_c('span',[_vm._v("Zarządzanie")])])}
var staticRenderFns = []

export { render, staticRenderFns }